import App from "App";
import { PUBLIC_URL } from "customGlobal";
import { lazy } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider
} from "react-router-dom";

const Home = lazy(() => import("pages/Home"));
const Action = lazy(() => import("pages/Action"));
const NoMatch = lazy(() => import("pages/NoMatch"));

const basename = PUBLIC_URL != "/" ? PUBLIC_URL.replace(/\/+$/, "") : PUBLIC_URL;

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route index element={<Home />} />
      <Route path="/action/:type" element={<Action />} />
      <Route path="*" element={<NoMatch />} />
    </Route>
  ),
  {
    basename: basename
  }
);

export function RouterRoot() {
  return <RouterProvider router={router} />;
}
